import React from 'react';

const Input = ({ 
  label, 
  type = 'text', 
  value, 
  onChange, 
  placeholder, 
  required = false, 
  error = null,
  className = '',
  mask = null
}) => {
  const handleChange = (e) => {
    let newValue = e.target.value;
    
    if (mask === 'phone') {
      newValue = applyPhoneMask(newValue);
      // Cria um novo evento com o valor formatado
      const formattedEvent = {
        ...e,
        target: {
          ...e.target,
          value: newValue
        }
      };
      onChange(formattedEvent);
    } else {
      onChange(e);
    }
  };

  const applyPhoneMask = (value) => {
    // Remove todos os caracteres não numéricos
    const numbers = value.replace(/\D/g, '');
    
    // Se não tem números, retorna vazio
    if (numbers.length === 0) return '';
    
    // Se tem menos de 2 dígitos, retorna apenas os números
    if (numbers.length <= 2) return numbers;
    
    // Se tem 2 dígitos, adiciona parênteses: (11)
    if (numbers.length === 2) return `(${numbers})`;
    
    // Se tem 3-6 dígitos: (11) 9999
    if (numbers.length <= 6) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    }
    
    // Se tem 7-10 dígitos: (11) 99999-9999
    if (numbers.length <= 10) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
    }
    
    // Limita a 11 dígitos (DDD + 9 dígitos)
    const limitedNumbers = numbers.slice(0, 11);
    return `(${limitedNumbers.slice(0, 2)}) ${limitedNumbers.slice(2, 7)}-${limitedNumbers.slice(7)}`;
  };

  const handleKeyDown = (e) => {
    if (mask === 'phone') {
      const currentValue = e.target.value;
      const numbers = currentValue.replace(/\D/g, '');
      
      // Se não tem DDD (menos de 2 dígitos) e tenta apagar, impede
      if (numbers.length <= 2 && (e.key === 'Backspace' || e.key === 'Delete')) {
        e.preventDefault();
        return;
      }
      
      // Se não é um número e não é uma tecla de controle, impede
      if (!/\d/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
        e.preventDefault();
        return;
      }
    }
  };

  return (
    <div className={`mb-3 ${className}`}>
      <label className="block text-base font-medium text-gray-700 mb-1">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <input
        type={type}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        maxLength={mask === 'phone' ? 15 : undefined}
        className={`
          w-full px-3 py-2 text-base border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors
          ${error ? 'border-red-500' : 'border-gray-300'}
        `}
      />
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

export default Input;
